import React, { useEffect, useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import ProductDetails from '../steps/ProductDetails'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { defaultSalesChannelProductInfo } from '../InterfaceSalesChannelModal'
import {
  GET_PRODUCT_DETAILS,
  UPDATE_SALES_CHANNEL,
} from '../../../../../utils/GraphQLAPI'
import { useLazyQuery, useMutation } from '@apollo/client'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import Dropdown from '../../../../sharedComponent/Dropdown/Dropdown'

interface Props {
  salesData: any,
  fetchSalesChannel: () => void
}

const ProductInfo = ({ salesData, fetchSalesChannel }: Props) => {
  const [commodity, setCommodity] = useState<any>()
  const [customerType, setCustomerType] = useState<any>()
  const [utilities, setUtilities] = useState<any>()
  const [disabled, setDisabled] = useState<boolean>(true);
  const [btnShow, setBtnShow] = useState<boolean>(false);
  const [productEdit, setProductEdit] = useState<boolean>(true);
  const [loading, setLoading] = useState<boolean>(false); // Loading state for spinner

  const handleEdit = () => {
    setDisabled(false)
    setBtnShow(true)
    setProductEdit(false);
  }

  const MySwal = withReactContent(Swal)

  const [getProductDetails] = useLazyQuery(GET_PRODUCT_DETAILS, {
    onCompleted: (data) => {
      setUtilities(data?.getProductDetail[1]?.names)
      setCommodity(data?.getProductDetail[0]?.names)
      setCustomerType(data?.getProductDetail[4]?.names)
    },
    fetchPolicy: 'network-only',
  })

  useEffect(() => {
    getProductDetails()
  }, [])

  const salesId = localStorage.getItem('salesEditId')
  const salesChannelInfoSchema = Yup.object().shape({})

  const [updateSalesChannel] = useMutation(UPDATE_SALES_CHANNEL, {
    onCompleted: (data) => {
      const options: any = {
        customClass: {
          popup: 'swal2-border-radius',
        },
        title: 'Sales Channel product info updated successfully',
        icon: 'success',
        confirmButtonColor: '#3E97FF',
      }
      MySwal.fire(options)
      formik.setFieldValue('deletedProductId', [])
      setDisabled(true)
      setBtnShow(false)
      fetchSalesChannel() // Refetch data
      setLoading(false) // Stop spinner after successful completion
    },
    onError: (e) => {
      MySwal.fire({
        icon: 'error',
        title: e.message,
      })
      formik.setFieldValue('deletedProductId', [])
      setDisabled(true)
      setBtnShow(false)
      setLoading(false) // Stop spinner on error
    }
  })

  const formik = useFormik({
    initialValues: defaultSalesChannelProductInfo,
    validationSchema: salesChannelInfoSchema,
    enableReinitialize: true,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      setLoading(true) // Start spinner when submitting
      const productIds: any = values.productIds;
      const filteredProductId = productIds;
      const salesProductIds = salesData.products.map((product: { prod_id: any }) => product.prod_id);
      const missingProductIds = filteredProductId.filter((id: any) => !salesProductIds.includes(id));

      updateSalesChannel({
        variables: {
          updateSalesChannelInput: {
            id: salesId,
            salesChannelProductIds: missingProductIds,
            ...(values.deletedProductId && { deletedProductIds: values.deletedProductId })
          }
        }
      })
    },
  })

  const handleSelectedItem = (e: any, name: any) => {
    if (e.value.length > 0) {
      formik.setFieldValue(name, e.label);
      formik.setFieldValue(`${name}Id`, e.value);
    } else {
      formik.setFieldValue(name, '');
      formik.setFieldValue(`${name}Id`, null);
    }
  }

  const handleDiscard = () => {
    setDisabled(true)
    setBtnShow(false)
    setProductEdit(true);
    formik.setErrors({})
  }

  return (
    <div>
      <div className='pb-5 p-4' data-kt-stepper-element='content'>
        <div className='w-100'>
          <form className='' onSubmit={formik.handleSubmit}>
            <div className='row mb-2'>
              <div className="col-6">
                <label className='d-flex align-items-center fs-4 fw-bold mb-4 lh-1'>
                  <span className='fs-2 fw-bolder text-gray-900'>Assign Products</span>
                </label>
              </div>
              <div className='col-6 text-end'>
                {!btnShow && <button
                  type="button"
                  className='btn btn-primary text-white btn-active-color-primary btn-md me-1'
                  onClick={() => handleEdit()}
                  data-kt-menu-trigger='click'
                  data-kt-menu-placement='bottom-end'
                  style={{ position: 'absolute', right: '20px', top: '48px', height: '35px', display: 'flex', alignItems: 'center' }}
                >
                  Edit
                </button>}
              </div>
            </div>
            <div className='hover-scroll-overlay-y px-3' style={{ paddingBottom: '10px', minHeight: '250px' }}>
              <Row className='mb-5 d-flex align-items-end mt-5 no-gutters noPadding'>
                <Col sm={4} md={4} className='mr-0 ml-0 pb-5'>
                  <label className='d-flex align-items-center mb-2'>
                    <span className='fs-6 fw-semibold lh-23px'>Utility </span>
                  </label>
                  <Dropdown
                    fieldName='utility'
                    optionList={utilities}
                    handleSelectedItem={handleSelectedItem}
                    formik={formik}
                    fieldDisabled={disabled}
                  />
                </Col>
                <Col sm={4} md={4} className='mr-0 ml-0 pb-5'>
                  <label className='d-flex align-items-center mb-2'>
                    <span className='fs-6 fw-semibold lh-23px'>Commodity</span>
                  </label>
                  <Dropdown
                    fieldName='commodity'
                    optionList={commodity}
                    handleSelectedItem={handleSelectedItem}
                    formik={formik}
                    fieldDisabled={disabled}
                  />
                </Col>
                <Col sm={4} md={4} className='mr-0 ml-0 pb-5'>
                  <label className='d-flex align-items-center mb-2'>
                    <span className='fs-6 fw-semibold lh-23px'>Customer Type</span>
                  </label>
                  <Dropdown
                    fieldName='customerType'
                    optionList={customerType}
                    handleSelectedItem={handleSelectedItem}
                    formik={formik}
                    fieldDisabled={disabled}
                  />
                </Col>
              </Row>

              <Row className='mb-5 d-flex align-items-end mt-5 no-gutters noPadding'>
                <ProductDetails isEdit={productEdit} formik={formik} salesDatas={salesData} salesProducts={null} label="Choose Products" />
              </Row>
            </div>
            <div className='d-flex flex-stack pt-5'>
              <div className='me-2'></div>
              <div>
                <button type='reset' className={`btn btn-lg btn-light ${btnShow ? null : 'd-none'}`} onClick={() => handleDiscard()}>Discard</button>
                <button
                  type='submit'
                  className={`btn btn-lg btn-primary mx-5 ms-4 ${btnShow ? null : 'd-none'}`}
                  disabled={loading} // Disable button when loading
                  onClick={() => { setProductEdit(true) }}
                >
                  {loading ? (<>Updating <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span></>) : 'Update'}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default ProductInfo
